<template>
  <el-container style="width: 100%;height: 100%;display: flex;flex-direction: column;">
    <el-row style="width: 100%;height: 100%;display: flex;flex-direction: row;">
      <el-aside style="height: 100%;width: 250px;margin-right: 1px;background-color: #ffffff;">
        <el-row class="doc-tree-top">
          <el-input style='width: 100%; border: none; outline: none' class="filter-search" placeholder="输入关键字搜索" prefix-icon="zy-icon-search" v-model="filterName"/>
        </el-row>
        <el-tree :data="treeData" :props="defaultProps" @node-click="handleNodeClick" node-key='id' :filter-node-method="filterNode"
                 :default-expanded-keys="expandKeys" highlight-current ref="tree" class="aside-tree">
        <span slot-scope="{ node, data }">
          <i v-if="node.data.type === '1'" class="zy-icon-building"></i>
          <i v-if="node.data.type === '2'" class="zy-icon-commit"></i>
          <i v-if="node.data.type === '3'" class="zy-icon-sensor"></i>
          <span>{{ node.label }}</span>
        </span>
        </el-tree>
      </el-aside>
      <el-main style="overflow-y: hidden;font-size: 14px;width: calc(100% - 251px);height: 100%;background-color: #ffffff;">
        <el-row class="tt-input" style="width: 100%;display: flex;height: 48px;line-height: 48px;color: rgb(127, 127, 127);">
          <el-row style="text-align: left;width: 40%;height: 48px;line-height: 48px;">
            <span style="margin-left: 24px;">起止日期：</span>
            <el-date-picker v-model="startDate" style="width: 138px;margin-left: 4px;"
                            placeholder="选择日期" value-format="yyyy-MM-dd" :clearable="false"/>
            <span>-</span>
            <el-date-picker v-model="endDate" style="width: 138px;margin-left: 4px;"
                            placeholder="选择日期" :clearable="false" value-format="yyyy-MM-dd"/>
            <el-button class="search-btn-blue" style="margin-left: 14px;" @click="getChartData(selNode)" type="primary" size="mini">查询</el-button>
          </el-row>
          <el-row style="text-align: right;width: 60%;height: 48px;line-height: 48px;">
            <el-radio-group class="tt-input" style="margin-right: 10px;" size="small" v-model="radioBtn" @change="selBack">
              <el-radio-button v-for="(radioItem, i) in radioGroups" :key="i" :label="i">{{radioItem.typeName}}</el-radio-button>
            </el-radio-group>
          </el-row>
        </el-row>
        <el-row style="background-color: #fff;width: 100%; height: 1px;"></el-row>
        <el-row style="overflow-y: auto;height: calc(100% - 49px);width: 100%;">
          <el-row style="height: calc(50% - 1px);width: 100%;">
            <el-row style="background-color: rgba(2, 124, 247, 0.8);width: 100%; height: 48px;">
              <span style="text-align: left;height: 48px;line-height: 48px;margin-left: 24px;color: rgb(247, 247, 247);display: flex;">数据曲线</span>
            </el-row>
            <common-charts :init-options="initOptions" :class="tableShow?'electric-parameter-charts':'new-electric-parameter-charts'"
                           :index="200" :key="timestamp" :options="chartData" autoresize :style="{'height': ((bgSize.height - 194) / 2) + 'px', 'width': (bgSize.width - 452) + 'px'}" />
          </el-row>
          <el-row style="height: 1px;width: 100%;background-color: #FFF" />
          <el-row style="height: calc(50% - 1px);width: 100%;" v-show='tableShow' class="table">
            <el-row style="background-color: rgba(2, 124, 247, 0.8);width: 100%; height: 48px;">
              <el-menu :default-active="0" class="horizontal-menu" @select="panelSelect"
                       mode="horizontal" unique-opened background-color="rgba(0, 0, 0, 0)" text-color="rgba(242, 242, 242, 1)">
                <el-menu-item class="horizontal-menu-item" :key="0" :index="0">
                  <span style="font-size: 14px;">极值</span>
                </el-menu-item>
                <el-menu-item class="horizontal-menu-item" :key="1" :index="1">
                  <span style="font-size: 14px;">说明</span>
                </el-menu-item>
              </el-menu>
            </el-row>
            <el-table v-show="selPanel === 0" border fit :data="tableData" height="calc(100% - 48px)" width="100%" ref="tableData">
              <el-table-column v-for="(item,i) in tableProps" :key="i+tableData"
                               :prop="item.prop" :label="item.label" :width="item.width">
              </el-table-column>
            </el-table>
            <el-row v-show="selPanel === 1" style="width: 99%; height: calc(100% - 48px);text-align: left;font-size: 14px;margin-left: 1%;overflow-y: auto;">
              <el-row style="height: 32px;line-height: 32px;margin-top: 8px;">功率因数低的危害：</el-row>
              <el-row style="height: 32px;line-height: 32px;">1. 增加力调电费。</el-row>
              <el-row style="height: 32px;line-height: 32px;">2. 电网损耗大。</el-row>
              <el-row style="height: 32px;line-height: 32px;">3. 用户侧电压偏移。</el-row>
              <el-row style="height: 32px;line-height: 32px;margin-top: 8px;">功率因数的国家标准：</el-row>
              <el-row style="height: 32px;line-height: 32px;">1. 功率因数 ≥ 0.9（国家电网）。</el-row>
              <el-row style="height: 32px;line-height: 32px;margin-top: 8px;">功率因数治理方法：</el-row>
              <el-row style="height: 32px;line-height: 32px;">1. SVG。</el-row>
              <el-row style="height: 32px;line-height: 32px;">2. 并联电容器（感性线路）。</el-row>
              <el-row style="height: 32px;line-height: 32px;">3. 并联电感器（容性电路）。</el-row>
            </el-row>
          </el-row>
        </el-row>
      </el-main>
    </el-row>
  </el-container>
</template>

<script>
import buildQualityConfig from "../../../config/chart/config_quality_line";
import CommonCharts from "../../common/chart/CommonCharts";
export default {
  name: "PowFactorAnalyse",
  components: {CommonCharts},
  data() {
    return {
      timestamp: 0,
      chartData: {},
      initOptions: {
        renderer: 'canvas'
      },
      selNode: '',
      radioGroups: '',
      radioBtn: 0,
      treeData: [],
      tableData: [],
      expandKeys: [],
      defaultProps: {
        children: 'childNode',
        label: 'name'
      },
      tableShow: true,
      startDate: new Date().Format('yyyy-MM-dd'),
      defaultRadio: '',
      endDate: new Date().Format('yyyy-MM-dd'),
      tableProps: [
        {prop: "dataName", label: "电参名称"},
        {prop: "maxData", label: "最大值"},
        {prop: "maxTime", label: "最大时间"},
        {prop: "minData", label: "最小值"},
        {prop: "minTime", label: "最小时间"},
        {prop: "avgData", label: "平均值"}
      ],
      panelData: {
        queryMethod: this.$api.energyMonitor.getAllSensorParam,
        typeBack: 'changeable',
        filterForm: [
          {label: '起止时间：', prop: 'sensor_name', type: 'date', value: '', style: 'width: 120px;'},
          {label: '', prop: 'sensor_name', type: 'date', value: '', style: 'width: 120px;'},
          {label: '数据类型: ', prop: 'typeId', type: 'radioBtn', value: '',
            props: {value: 'typeId', label: 'typeName'},
            options: [],
            changeBack: this.selBack
          }
        ],
        buttons: [],
        methods: [],
        tableCheck: false,
        tableProps: [
          {prop: "sensorName", label: "电参名称"},
          {prop: "sensorAddr", label: "最大值"},
          {prop: "status", label: "最大时间"},
          {prop: "commName", label: "最小值"},
          {prop: "status", label: "最小时间"},
          {prop: "commName", label: "平均值"}
        ]
      },
      unit: '',
      bgSize: {'width': window.innerWidth, 'height': window.innerHeight},
      filterName: '',
      selPanel: 0
    }
  },
  created() {
    let params = 'mediaId=1&typeId=6'
    this.$api.energyMonitor.getQualityDataType(params).then(res => {
      this.radioGroups = res.data
      if (res.data.length > 0) {
        this.unit = res.data[0].unit
      }
      this.getTree('1')
    })
    // console.log(this.bgSize)
  },
  mounted() {
    window.addEventListener('resize', () => {
      this.bgSize.width = window.innerWidth
      this.bgSize.height = window.innerHeight
      this.timestamp = new Date().getTime()
    })
  },
  watch: {
    filterName(val) {
      this.$refs.tree.filter(val);
    }
  },
  methods: {
    panelSelect(val) {
      this.selPanel = val
    },
    getTree(val) {
      this.$api.systemManage.getSensorTree(val).then(res => {
        this.treeData = res.data
        if (this.treeData && this.treeData.length > 0) {
          this.selNode = this.getLeafNode(this.treeData[0])
          let nodeIdName = 'id'
          this.$nextTick(function () {
            this.setTreeCurrent(this.selNode[nodeIdName], 1)
          })
        }
      })
    },
    getLeafNode(pNode) {
      let leafNode = pNode;
      if (pNode.childNode && pNode.childNode.length > 0) {
        leafNode = this.getLeafNode(pNode.childNode[0])
      }
      return leafNode
    },
    handleNodeClick(cNode, node) {
      this.selNode = cNode;
      if(node.data.type === '3') {
        this.getChartData(this.selNode)
      }
    },
    setTreeCurrent(key, time) {
      if (time > 10) throw new Error('没有找到 树组件')
      let tree = this.$refs.tree
      if (tree) {
        tree.setCurrentKey(key)
        this.expandKeys.push(key)
        let node = tree.getNode(key)
        if (key !== -1) tree.$emit("node-click", node.data, node, tree)
      } else {
        this.setTreeCurrent(key, time + 1)
      }
    },
    selBack(val) {
      this.unit = this.radioGroups[val].unit
      this.getChartData(this.selNode)
    },
    filterNode(value, data) {
      if (!value) return true;
      return data['name'].indexOf(value) !== -1;
    },
    getChartData(node) {
      if (node.type !== '3') {
        return
      }
      let params = {'id': node.id, 'startDate': this.startDate, 'endDate': this.endDate, 'dataType': this.radioGroups[this.radioBtn].typeId}
      this.$api.energyAnalyse.getCurveByType(params).then(res => {
        let xAxis = res.data.dataTime
        let data = []
        let legend = res.data.dataItem
        this.tableData = []
        res.data.curveList.forEach((sd) => {
          data.push({
            name: sd.dataName,
            type: 'line',
            data: sd.dataData.split(","),
            markPoint: {
              data: [
                {type: 'max', name: '最大值'},
                {type: 'min', name: '最小值'}
              ]
            },
            markLine: {
              data: [
                {type: 'average', name: '平均值'},
                {name: '基准线', yAxis: 0.9, lineStyle: {color: '#FF0000'}, label: {formatter: '0.9 {b}', position: 'end', color: '#FF0000'}}
              ]
            }
          })
          this.tableData.push({
            maxTime: sd.maxTime,
            maxData: sd.maxData,
            minTime: sd.minTime,
            avgData: sd.avgData,
            dataName: sd.dataName,
            minData: sd.minData
          })
        })
        this.chartData = buildQualityConfig(legend, xAxis, data, 0.9, this.unit)
        this.timestamp = new Date().getTime()
      })
    }
  }
}
</script>
<style scoped>
  .doc-tree-top{
    display: inline-flex;
    align-items: center;
    height: 49px;
    width: 250px;
    border-bottom: 1px solid #fff;
  }
  .electric-parameter-charts{
    width: 100%;
    margin-top: 0;
  }
  .new-electric-parameter-charts{
    width: 100%;
    padding: 0;
  }
  /*.table /deep/ .el-table tr {*/
  /*  background-color: transparent!important;*/
  /*}*/
  .table /deep/ .el-table th {
    background-color: rgba(2, 124, 247, 0.2);
    border-top: 0;
  }
  /*.table /deep/ .el-table--enable-row-transition .el-table__body td, .el-table .cell{*/
  /*  background-color: transparent;*/
  /*}*/
</style>



// WEBPACK FOOTER //
// src/components/EnergyEfficiency/EnergyQuality/PowFactorAnalyse.vue